import Router from "@/common/router/Router";

export default class CalculationRouter extends Router {
  static BASE_PATH = "/calculation";
  static SHOW_ROUTE_NAME = "calculation-show";
  static CREATE_ROUTE_NAME = "calculation-create";
  static UPDATE_ROUTE_NAME = "calculation-update";
  static LIST_ROUTE_NAME = "calculation-list";
  private static _instance: CalculationRouter;
  public static instance(): CalculationRouter {
    if (!CalculationRouter._instance) {
      CalculationRouter._instance = new CalculationRouter();
    }
    return CalculationRouter._instance;
  }

  private constructor() {
    super(
      CalculationRouter.BASE_PATH,
      CalculationRouter.SHOW_ROUTE_NAME,
      CalculationRouter.CREATE_ROUTE_NAME,
      CalculationRouter.UPDATE_ROUTE_NAME,
      CalculationRouter.LIST_ROUTE_NAME
    );
  }
}
